import "./header.js";
import "./anchor-links.js";
// import "./aos-animate.js";
import "./video.js";
import "./blog-load-more.js";

document.addEventListener('DOMContentLoaded', async () => {
  const body = document.body;
  const isHome = body && (body.classList.contains('home') || body.classList.contains('front-page'));
  if (isHome) {
    return;
  }

  const mod = await import('./transitions.js');
  if (mod && typeof mod.initTransitions === 'function') {
    mod.initTransitions();
  }
});
